import React, { useEffect, useState } from "react";
import { Imagesdata } from "../../assets/images/imageData";
import Layout from "../../layout";
import { useForm } from "react-hook-form";
import "react-datepicker/dist/react-datepicker.css";
import validation from "./validation";
import { Table, Button, Modal, Form, Container, Row, Col } from "react-bootstrap";
import services from "../../API/services";
import { useSelector } from "react-redux";
import { authenticationSeletor } from "../../store/slices/authenticationSlice";
import Select from "react-select";
import { createOptions } from "../../utils/utils";
import Moment from "react-moment";
import { useRef } from "react";
import { useDownloadExcel } from "react-export-table-to-excel";
import moment from "moment";
import ReactGA from "react-ga4";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { mainUrl } from "API/client/api";
import axios from "axios";

const Laundry = () => {
  const { userDetail } = useSelector(authenticationSeletor);

  useEffect(() => {
    window.scrollTo(0, 0);
    getDataHandler(userDetail?.propertyId);
    getDataHandlerServiceProvide(userDetail?.propertyId);
    getDataHandlerService(userDetail?.propertyId);
  }, [userDetail]);

  const [laundryServices, setLaundryServices] = useState([]);
  const { AlertIcon } = Imagesdata || {};
  const [exportFilter, setExportFilter] = useState({ startDate: new Date(), endDate: new Date() });

  const [show, setShow] = useState(false);
  const [viewPopup, setViewPopup] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [selectedData, setSelectedData] = useState({});
  const [statusPopup, setStatusPopup] = useState(false);
  const [statusRemark, setStatusRemark] = useState("");
  const [tableData, setTableData] = useState([]);
  const [tableDataFilter, setTableDataFilter] = useState([]);
  const [ServiceData, setServiceData] = useState([]);
  const [serviceMaster, setServiceMaster] = useState([]);
  const [totalPrice, setTotalPrice] = useState([]);
  const [inQty, setInQty] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [quantity, setQuantity] = useState(null);
  const [items, setItems] = useState([{ serviceName: "", quantity: "", price: "", expectedDate: "" }]);
  const { watch, register, handleSubmit, reset, setValue, getValues, formState: { errors } } = useForm({ ...validation, mode: "onSubmit" });

  const onSubmit = async (payload) => {
    try {
      let service = payload.service
        ?.filter(x => x?.quantity)
        .map((x, idx) => ({
          service_id: items[idx]?.serviceName?.value,
          quantity: Number(x?.quantity),
          total_service_amount: Number(x?.quantity) * Number(items[idx]?.price),
          expectedDate: x?.expectedDate,
        }));
      const realPayload = {
        property_id: userDetail?.propertyId,
        provider_id: payload.selectProvider,
        remark: payload.remark,
        service,
        createdBy: userDetail?.id,
      };
      const res = await services.globalService.createLaundryReqService(realPayload);
      if (res.status == 200 || res.status == 201) { closeModal(); getDataHandler(userDetail?.propertyId) }
    } catch (error) { console.log(error) }
  };

  // const onSubmit = async (payload) => {
  //   try {
  //     let service = items
  //       .filter(x => x?.price)
  //       .map((x, index) => {
  //         let qty = x[`service.${index}.quantity`];
  //         let exp = x[`service.${index}.expectedDate`];
  //         return {
  //           service_id: x?.serviceName.value,
  //           quantity: Number(qty),
  //           total_service_amount: Number(qty) * x?.price,
  //           expectedDate: exp,
  //         };
  //       });
  //     const realPayload = {
  //       property_id: userDetail?.propertyId,
  //       provider_id: payload.selectProvider,
  //       remark: payload.remark,
  //       service,
  //       createdBy: userDetail?.id,
  //     };
  //     const res = await services.globalService.createLaundryReqService(realPayload);
  //     if (res.status == 200 || res.status == 201) {
  //       closeModal();
  //       getDataHandler(userDetail?.propertyId);
  //     }
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  const getDataHandler = async (id) => {
    try {
      const res = await services.globalService.getLaundryServiceResByIdService(id);
      if (res.status == 200) {
        setTableData(res.data.data);
        const request = res?.data?.data?.map((item) => item?.LaundaryRequests);
        const req2 = request?.map((item) => {
          let myData = 0;
          item?.map((data) => (myData += data?.quantity * data?.LaundaryService?.price));
          return { amt: myData, id: item[0]?.orderId };
        });
        setTotalPrice(req2);
      }
    } catch (error) { }
  };

  // const getDataHandler = async (id) => {
  //   try {
  //     const res = await axios.get(`${mainUrl}api/rrooms-property/laundary-request?property_id=${id}`);
  //     if (res.status == 200) {
  //       setTableData(res.data.data);
  //       const request = res?.data?.data?.map((item) => item?.LaundaryRequests);
  //       const req2 = request?.map((item) => {
  //         let myData = 0;
  //         item?.map((data) => (myData += data?.quantity * data?.LaundaryService?.price));
  //         return { amt: myData, id: item[0]?.orderId };
  //       });
  //       setTotalPrice(req2);
  //     }
  //   } catch (error) { }
  // };

  const getDataHandlerServiceProvide = async (id) => {
    try {
      const res = await services.globalService.getLaundryProviderByIdService(id);
      if (res.status == 200) { setLaundryServices(res.data.data) }
    } catch (error) { console.log("Error in getDataHandlerServiceProvide function."); }
  };

  const selectedProvider = watch("selectProvider");

  const getDataHandlerService = async (id) => {
    try {
      const providerParam = selectedProvider ? `&providerId=${selectedProvider}` : "";
      const res = await services.globalService.getLaundryServicesByIdService(`?property_id=${id}${providerParam}`);
      if (res.status == 200) {
        setServiceMaster(res.data.data);
        const dataSet = createOptions(res.data.data, "name", "id");
        setServiceData(dataSet);
      }
    } catch (error) { console.log("Error in getDataHandlerService function."); }
  };

  useEffect(() => { if (userDetail?.propertyId) { getDataHandlerService(userDetail?.propertyId) } }, [selectedProvider]);

  const addItem = () => { setItems([...items, { id: Date.now(), serviceName: "", quantity: "", price: "", expectedDate: "" }]) };

  // const closeHandler = (i) => { const copy = [...items]; copy.splice(i, 1); setItems(copy) };

  const closeHandler = (i) => {
    const copy = [...items];
    copy.splice(i, 1);
    setItems(copy);
    const updatedService = getValues("service") || [];
    updatedService.splice(i, 1);
    setValue("service", updatedService);
  };

  // const closeHandler = (index) => {
  //   let tempData = [...items];
  //   tempData.splice(index, 1);
  //   setItems(tempData);
  // };

  // const changeHandler = (e, index) => {
  //   let tempData = [...items];
  //   tempData[index][e.target.name] = e.target.value;
  //   tempData[index].createdBy = userDetail?.id;
  //   setItems(tempData);
  // };

  const changeHandler = (e, index) => { let list = [...items]; list[index][e.target.name] = e.target.value; setItems(list) };

  // const selectChangeHandler = (data, index) => {
  //   let tempData = [...items];
  //   tempData[index].serviceName = data;
  //   const getSelectEdData = serviceMaster.find((dataSet) => {if (dataSet.id == data.value) {return dataSet}});
  //   tempData[index].price = getSelectEdData.price;
  //   setItems(tempData);
  // };

  const selectChangeHandler = (data, index) => {
    const copy = [...items];
    copy[index].serviceName = data;
    const selected = serviceMaster.find(x => x.id == data.value);
    copy[index].price = selected?.price || 0;
    setItems(copy);
  };

  const closeModal = () => { setShow(false); reset(); setItems([{ serviceName: "", quantity: "", price: "", expectedDate: "" }]) };

  const statusChangeHandler = async () => {
    let payload = { id: selectedData?.id, body: { remark: statusRemark, in_qty: Number(inQty) + Number(selectedData?.inQty || 0), updated_by: userDetail?.id } };
    try {
      const res = await services.globalService.changeStatusLaunrdryService(payload);
      if (res.status == 200) {
        getDataHandler(userDetail?.propertyId);
        setStatusPopup(false);
        setSelectedData({});
        setStatusRemark("");
        setInQty(null);
      }
    } catch (error) { }
  };

  const tableRef = useRef();

  const { onDownload } = useDownloadExcel({ currentTableRef: tableRef.current, filename: "laundry", sheet: "laundry" });

  useEffect(() => { ReactGA.send({ hitType: "pageview", page: "laundry" }); setTableDataFilter(tableData) }, [tableData]);

  const [filterDate, setFilterDate] = useState(new Date());

  const searchfilter = (text) => {
    setSearchText(text)
    const resultsData = tableData.filter((order) => {
      if (text == "") return tableData;
      return (
        order?.LaundaryRequests[0]?.LaundaryService?.name +
        order?.LaundaryRequests[0]?.LaundaryProvider?.name +
        order?.LaundaryRequests[0]?.LaundaryProvider?.providerCode +
        order?.LaundaryRequests[0]?.remark +
        order?.LaundaryRequests[0]?.status +
        order?.createdBy +
        order?.totalAmount +
        order?.id
      )?.toString().toLowerCase()?.includes(text?.toLowerCase())
    });
    setTableDataFilter(resultsData);
  };

  const dateFilter = () => {
    const resultsData = tableData.filter((order) => {
      return (new Date(order?.createdAt).toJSON().slice(0, 10) >= new Date(filterDate).toJSON().slice(0, 10))
    });
    setTableDataFilter(resultsData);
  };

  useEffect(() => { dateFilter() }, [filterDate]);

  const exportHandler = async () => {
    window.open(`${mainUrl}api/kpi/loundary-report?fromDate=${moment(exportFilter.startDate).format("YYYY-MM-DD")}&toDate=${moment(exportFilter.endDate).format("YYYY-MM-DD")}&propertyId=${userDetail?.propertyId}${searchText ? "&search=" + searchText : ""}`, "_blank")
  };

  const firstRequest = selectedData?.LaundaryRequests?.length ? selectedData.LaundaryRequests[0] : null;

  const getProviderDetails = firstRequest?.LaundaryProvider || {};

  const downloadPDF = () => {
    const pdf = new jsPDF("p", "mm", "a4");
    const primary = [26, 115, 232];   // Blue
    const greyBox = [245, 245, 245];  // Light grey
    // ---------- HEADER BAR ----------
    pdf.setFillColor(...primary);
    pdf.rect(0, 0, 210, 20, "F");
    pdf.setTextColor(255, 255, 255);
    pdf.setFont("helvetica", "bold");
    pdf.setFontSize(15);
    pdf.text("Laundry Order Summary", 14, 13);
    // ---------- PROVIDER DETAILS BOX ----------
    pdf.setFillColor(...greyBox);
    pdf.rect(10, 28, 190, 28, "F");
    pdf.setTextColor(0, 0, 0);
    pdf.setFont("helvetica", "bold");
    pdf.setFontSize(12);
    pdf.text("Provider Details", 14, 30);
    pdf.setFontSize(10);
    pdf.setFont("helvetica", "normal");
    const leftX = 16;
    const rightX = 112;
    const baseY = 40;
    pdf.text(`Name: ${getProviderDetails?.name || "-"}`, leftX, baseY);
    pdf.text(`Email: ${getProviderDetails?.email || "-"}`, leftX, baseY + 6);
    pdf.text(`Mobile: ${getProviderDetails?.phone || "-"}`, rightX, baseY);
    pdf.text(`Alt. Mobile: ${getProviderDetails?.alternateMobile || "-"}`, rightX, baseY + 6);
    // ---------- TABLE ----------
    const tableColumn = ["Service", "Out-Qty", "In-Qty", "Price", "Total Amount", "Expected Date", "Remark"];
    const tableRows = [];
    selectedData?.LaundaryRequests?.forEach((item) => {
      tableRows.push([
        item?.LaundaryService?.name || "-",
        item?.quantity || 0,
        item?.inQty || 0,
        `${item?.LaundaryService?.price || 0}`,
        `${(item?.LaundaryService?.price || 0) * (item?.quantity || 0)}`,
        item?.expectedDate || "-",
        item?.remark || "-"
      ]);
    });
    autoTable(pdf, {
      startY: 65,
      head: [tableColumn],
      body: tableRows,
      theme: "grid",
      headStyles: { fillColor: primary, textColor: 255, fontStyle: "bold", halign: "center" },
      bodyStyles: { fontSize: 9, halign: "center" },
      alternateRowStyles: { fillColor: [245, 245, 245] },
      columnStyles: {
        0: { halign: "left", cellWidth: 35 },
        3: { halign: "right" },
        4: { halign: "right" },
        5: { halign: "center", cellWidth: 30 },
        6: { halign: "left", cellWidth: 30 },
      }
    });
    // ---------- FOOTER ----------
    pdf.setFontSize(9);
    pdf.setTextColor(150);
    pdf.text("Generated by RRooms Platform", 14, 290);
    // OPEN PDF
    pdf.output("dataurlnewwindow");
  };

  return (
    // <Layout title="Laundry" openHandler={() => setShow(true)} extraBtnHandler={exportHandler} extraButton="Export Table" searchfilter={searchfilter} onChange={(e) => setSearchText(e.target.value)} setToDate={(date) => setExportFilter({ ...exportFilter, endDate: date })} dateFilter={exportFilter} searchType={"date"} fromDate={exportFilter.startDate} toDate={exportFilter.endDate} setFromDate={(date) => setExportFilter({ ...exportFilter, startDate: date })}>

    <Layout title="Laundry" searchType={"both"} openHandler={() => setShow(true)} extraBtnHandler={exportHandler} extraButton="Export Table"
      setToDate={(date) => setExportFilter({ ...exportFilter, endDate: date })} dateFilter={exportFilter} searchfilter={searchfilter} fromDate={exportFilter.startDate} toDate={exportFilter.endDate} setFromDate={(date) => setExportFilter({ ...exportFilter, startDate: date })}>
      <Table striped bordered hover className="inventoryTable" ref={tableRef}>
        <thead>
          <tr>
            <th>Sr No.</th>
            <th>Service Provider Code</th>
            <th>Service Provider Name</th>
            <th>Order Id</th>
            <th>Date</th>
            {/* <th>Remark</th> */}
            <th>Status</th>
            <th>Total Amount</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {tableDataFilter?.map((data, key) => {
            return (
              <tr
                key={key}
                className={`${data.LaundaryRequests?.filter((i) => i.quantity > i.inQty)?.length > 0 ? "noQtyAlert" : ""}`}>
                <td>{key + 1}</td>
                <td>{data?.LaundaryRequests[0]?.LaundaryProvider?.providerCode}</td>
                <td>{data?.LaundaryRequests[0]?.LaundaryProvider?.name}</td>
                <td>{data?.LaundaryRequests[0]?.orderId}</td>
                <td><Moment format="DD/MM/YYYY">{data.createdAt}</Moment></td>
                {/* <td>{data?.LaundaryRequests[0]?.remark ?? "N/A"}</td> */}
                <td className={data?.LaundaryRequests[0]?.status == "out" ? "text-danger" : "text-success"}>
                  {data?.LaundaryRequests[0]?.status?.toUpperCase() ?? "N/A"}
                </td>
                <td>₹ {totalPrice?.find((i) => i.id == data?.id).amt?.toFixed(2)}</td>
                <td>
                  <Button variant="primary" className=" btn-sm" onClick={() => { setViewPopup(true); setSelectedData(data) }}>
                    View
                  </Button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </ Table>

      <Modal backdrop="static" show={show} onHide={closeModal} size="lg">
        <Modal.Header><Modal.Title>Add Laundry Request</Modal.Title></Modal.Header>
        <Modal.Body>
          <Form className="popup-form onboardForm" onSubmit={handleSubmit(onSubmit)}>
            <Container>
              <Row>
                <Col xs={12} className="form-group">
                  <label>Select Service Provider</label>
                  <select {...register("selectProvider", { required: "Please select provider" })}
                    onClick={(e) => { setItems([{ serviceName: "", quantity: "", price: "", expectedDate: "" }]) }}>
                    <option value="">Select</option>
                    {laundryServices.map((data) => (<option key={data.id} value={data.id}>{data.name}</option>))}
                  </select>
                  {errors?.selectProvider && (
                    <div className="error-text"><img src={AlertIcon} alt="" /><span>{errors.selectProvider.message}</span></div>
                  )}
                </Col>
                {items.map((data, i) => (
                  <Col xs={12} key={i} className="addItems">
                    <Row>
                      {items.length > 1 && (
                        <Col xs={12}>
                          <div key={i} className="cutIcon" onClick={() => closeHandler(i)}>
                            <i className="fa fa-times" aria-hidden="true"></i>
                          </div>
                        </Col>
                      )}
                      <Col xs={12} className="form-group">
                        <label>Service name</label>
                        <Select options={ServiceData} placeholder="Select" value={data.serviceName} onChange={(val) => selectChangeHandler(val, i)} isSearchable />
                      </Col>
                      <Col xs={4} className="form-group">
                        <label>Quantity</label>
                        <input
                          type="number" className="form-control"
                          {...register(`service.${i}.quantity`, { required: "Please Enter Quantity*" })}
                          defaultValue={data.quantity}
                          onChange={(e) => { changeHandler(e, i); setValue(`service.${i}.quantity`, e.target.value) }}
                        />
                        {errors?.service?.[i]?.quantity?.message && (
                          <div className="error-text"><span>{errors.service[i].quantity.message}</span></div>
                        )}
                        {errors?.quantity?.message && (
                          <div className="error-text"><span>{errors.quantity.message}</span></div>
                        )}
                      </Col>
                      <Col xs={4} className="form-group">
                        <label>Price</label>
                        <input type="number" className="form-control" value={data.price} disabled />
                      </Col>
                      <Col xs={4} className="form-group">
                        <label>Expected Date</label>
                        <input type="date" className="form-control" min={new Date().toISOString().split("T")[0]}
                          {...register(`service.${i}.expectedDate`, { required: "Date is required" })}
                          defaultValue={data.expectedDate}
                          onChange={(e) => { changeHandler(e, i); setValue(`service.${i}.expectedDate`, e.target.value) }}
                        />
                        {errors?.service?.[i]?.expectedDate?.message && (
                          <div className="error-text"><span>{errors.service[i].expectedDate.message}</span></div>
                        )}
                      </Col>
                    </Row>
                  </Col>
                ))}
                <Col xs={12} className="form-group mt-2">
                  <Button variant="primary" type="button" className="buttonCenter" onClick={addItem}>+ Add Item</Button>
                </Col>
                <Col xs={12} className="form-group">
                  <label>Remark</label>
                  <textarea className="form-control" {...register("remark")}></textarea>
                </Col>
                <Col xs={12} className="form-group mt-4 d-flex justify-content-between">
                  <Button className="greyBtn" variant="outline-primary" onClick={closeModal}>Cancel</Button>
                  <Button variant="primary" type="submit">Submit</Button>
                </Col>
              </Row>
            </Container>
          </Form>
        </Modal.Body>
      </ Modal>

      <Modal show={viewPopup} onHide={() => { setViewPopup(false); setSelectedData({}) }} size="xl">
        <Modal.Header closeButton><Modal.Title>View Services</Modal.Title></Modal.Header>
        <Modal.Body>
          <Form className="popup-form">
            <Container>
              <Row>
                <Col xs={4} className="fs-7 text-black my-3 text-capitalize">Provider Name: {getProviderDetails.name}</Col>
                <Col xs={4} className="fs-7 text-black my-3">Email: <a href={`mailto:${getProviderDetails?.email}`}>{getProviderDetails?.email ?? "N/A"}</a></Col>
                <Col xs={2} className="fs-7 text-black my-3">Mobile: <a href={`tel:${getProviderDetails?.phone}`}>{getProviderDetails?.phone ?? "N/A"}</a></Col>
                <Col xs={2} className="fs-7 text-black my-3">Alt. No.: <a href={`tel:${getProviderDetails?.alternateMobile}`}>{getProviderDetails?.alternateMobile ?? "N/A"}</a></Col>
                <Col xs={12} className="form-group">
                  <Table striped bordered hover className="inventoryTable">
                    <thead>
                      <tr>
                        <th>Service</th>
                        <th>Out-Qty</th>
                        <th>In-Qty</th>
                        <th>Price</th>
                        <th>Total Amount</th>
                        <th>Expected Date</th>
                        <th>Remark</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {selectedData?.LaundaryRequests?.map((data, key) => (
                        <tr key={key}>
                          <td>{data?.LaundaryService?.name}</td>
                          <td>{data?.quantity}</td>
                          <td>{data?.inQty ?? 0}</td>
                          <td>₹ {data?.LaundaryService?.price}</td>
                          <td>₹ {data?.LaundaryService?.price * data?.quantity}</td>
                          <td>{data?.expectedDate ?? "N/A"}</td>
                          <td>{data?.remark ?? "N/A"}</td>
                          <td>
                            {data?.status !== "in" && (
                              <Button
                                variant="primary"
                                className="mr-2 btn-sm"
                                onClick={() => {
                                  setStatusPopup(true);
                                  setSelectedData(data);
                                  setViewPopup(false);
                                  setQuantity(data?.quantity)
                                }}
                              >
                                Change Status
                              </Button>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </Col>
              </Row>
              <Row className="mb-4">
                <Col xs={4} className="text-black">
                  Total Quantity:{" "}
                  {selectedData?.LaundaryRequests?.reduce((acc, item) => { return Number(acc) + Number(item.quantity) }, [0])}
                </Col>
                <Col xs={4} className="text-black text-center">
                  <button type="button" className="btn btn-sm btn-primary" onClick={downloadPDF}>Print</button>
                </Col>
                <Col xs={4} className="text-black text-end">
                  Total Amount: ₹{totalPrice?.find((i) => i.id == selectedData?.id)?.amt?.toFixed(2)}
                </Col>
              </Row>
            </Container>
          </Form>
        </Modal.Body>
      </ Modal>

      <Modal show={statusPopup} onHide={() => { setStatusPopup(false); setSelectedData({}); setStatusRemark(""); setInQty(null) }} size="lg">
        <Modal.Header closeButton><Modal.Title>Change Status</Modal.Title></Modal.Header>
        <Modal.Body>
          <Form className="popup-form onboardForm">
            <Container>
              <Row>
                <Col xs={12} className="form-group">
                  <label>Remark</label>
                  <textarea placeholder="Remarks" value={statusRemark} onChange={(e) => setStatusRemark(e.target.value)}></textarea>
                </Col>
                <Col xs={4} className="form-group">
                  <label>Out-Quantity</label>
                  <input style={{ color: "black", fontWeight: "500" }} value={selectedData?.quantity} disabled />
                </Col>
                <Col xs={4} className="form-group">
                  <label>In-Quantity</label>
                  <input style={{ color: "black", fontWeight: "500" }} value={selectedData?.inQty || 0} disabled />
                </Col>
                <Col xs={4} className="form-group">
                  <label>Remain-Quantity</label>
                  <input style={{ color: "black", fontWeight: "500" }} value={selectedData?.quantity - selectedData?.inQty} disabled />
                </Col>
                <Col xs={12} className="form-group">
                  <label>{selectedData?.inQty == null ? "In-" : "Remain In-"}Quantity</label>
                  <input placeholder={"Enter" + (selectedData?.inQty == null ? " In-" : " Remain In-") + "Quatity"} type="number"
                    onChange={(e) => {
                      const val = e.target.value;
                      if (/^\d*$/.test(val)) { setInQty(val); }
                    }}
                    onKeyDown={(e) => { if (["-", "+", "e", "E", "."].includes(e.key)) { e.preventDefault(); } }}
                    value={inQty} max={quantity} />
                  {
                    selectedData?.inQty == null
                      ? inQty > quantity
                        ? <small className="text-danger">In Quantity is not greater than Quantity.</small>
                        : ""
                      : inQty > (quantity - selectedData?.inQty)
                        ? <small className="text-danger">In Quantity is not greater than Remain Quantity.</small>
                        : ""
                  }
                </Col>
                <Col xs={12} className="form-group flex justify-content-between mt-4">
                  <Button className="greyBtn" variant="outline-primary" onClick={() => { setStatusPopup(false); setSelectedData({}) }}>
                    Cancel
                  </Button>
                  <Button variant="primary" type="button" onClick={statusChangeHandler} disabled={quantity < inQty}>Submit</Button>
                </Col>
              </Row>
            </Container>
          </Form>
        </Modal.Body>
      </ Modal>
    </ Layout>
  );
};

export default Laundry;
